<!--
  <ImportDdata
    :showBtn="false" // 是否显示上传按钮
    :downloadUrl="downloadUrl" // 下载模板文件地址
    :excelName="excelName" // 下载模板文件名称
    :uploadUrl="uploadUrl" // 上传模板文件地址
    :importParams="{channelId: channelId}" // 上传附加参数
    :tableData="importTable" // 表格数据
    @beginUpload="beginUpload" // 开始上传方法
    @returnData="returnData" // 上传完毕返回数据
  />
-->
<template>
  <!-- 导入文件数据 -->
  <el-row class="upload">
    <slot><el-button @click="downloadFile">下载模板</el-button></slot>
    <i class="el-icon-right"></i>
    <el-upload
      ref="upload"
      :action="uploadUrl"
      :headers="importHeaders"
      :disabled="disabled || loading"
      :name="importName"
      :data="importParams"
      :file-list="fileList"
      :show-file-list="false"
      :on-change="change"
      :on-remove="remove"
      :onError="uploadError"
      :onSuccess="uploadSuccess"
      :beforeUpload="beforeUpload"
    >
      <el-button type="primary" :disabled="loading">选择文件</el-button>
    </el-upload>
    <i v-show="showBtn" class="el-icon-right"></i>
    <el-button
      type="primary"
      v-show="showBtn"
      @click="submit"
      :loading="loading"
      :disabled="uploadBtnDisabled || tableData.length === 0 || loading"
    >{{ btnMsg }}</el-button>
    <span class="import-tips" v-if="tips">{{ tips }}</span>
  </el-row>
</template>

<script>
import download from '@/utils/download';
import { getItem } from '@/utils/cookie.js';

export default {
  name: 'ImportData',
  props: {
    // 下载模板文件名
    excelName: {
      type: String,
      default: '',
    },
    // 下载url
    downloadUrl: {
      type: String,
      default: '',
    },
    // 上传url
    uploadUrl: {
      type: String,
      default: '',
    },
    // 上传时附带的额外参数
    importParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 接口上传的文件字段名
    importName: {
      type: String,
      default: 'importfile',
    },
    // 显示上传文件按钮
    showBtn: {
      type: Boolean,
      default: true,
    },
    // 提示语
    tips: {
      type: String,
      default: '',
    },
    // 上传后的表格数据
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 提示语
    btnMsg: {
      type: String,
      default: '确定上传',
    },
    uploadBtnDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      disabled: false,
      loading: false,
      data: [],
      fileList: [],
      importData: [],
      maxSize: 100, // excel大小限制
      importHeaders: {
        enctype: 'multipart/form-data',
        'X-Tenant-Id': 'cml-main-service',
        'X-Session-Id': undefined,
        'X-Ext-Tenant-Id': localStorage.getItem('XExtTenantId'),
      },
    };
  },
  mounted() {
    if (getItem('sessionId')) {
      this.importHeaders['X-Session-Id'] = getItem('sessionId');
    } else if (localStorage.getItem('sessionId')) {
      this.importHeaders['X-Session-Id'] = localStorage.getItem('sessionId');
    }
    if (location.origin.includes('stgoms.yujiahui.com')) {
      this.importHeaders['region'] = 'gray'; // 预发布环境
    }
  },
  methods: {
    // 下载模板文件
    downloadFile() {
      download(this.downloadUrl, this.excelName);
    },
    change(file, fileList) {
      // 限制上传一个文件
      this.fileList = fileList.length > 1 ? fileList.slice(-1) : fileList;
      // fileList.length === 1 && this.checkFile(this.fileList[0]);
    },
    remove() {
      this.fileList = [];
      this.importData = [];
      this.$emit('returnData', []);
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      if (response.success) {
        let data = response.data;
        // 若用户管理导入返回的是对象，统一转为字符串处理
        if (Array.isArray(data)) {
          data = JSON.stringify(data);
        }
        this.importData = JSON.parse(data);
        this.$emit('returnData', JSON.parse(data));
        this.$emit('returnAllData', response);
        this.loading = false;
      } else {
        let msg = response.msg || '系统错误！';
        this.$message.error(msg);
        this.remove();
        this.loading = false;
        this.$emit('returnData', []);
      }
      this.$nextTick(() => {
        this.disabled = false;
      });
    },
    // 上传错误
    uploadError(err) {
      this.$nextTick(() => {
        this.disabled = false;
      });
      this.loading = false;
      this.$emit('returnData', []);
      this.$refs.upload.clearFiles();
      this.$message.error(err);
    },
    clearFiles() {},
    // 上传前对文件校验
    beforeUpload(file) {
      let excelFileExtend = '.xls,.xlsx,.csv'; //设置文件格式
      let fileExtend = file.name
        .substring(file.name.lastIndexOf('.'))
        .toLowerCase();
      if (excelFileExtend.indexOf(fileExtend) <= -1) {
        this.$message.error('文件格式错误!');
        this.fileList = [];
        this.$emit('returnData', []);
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < this.maxSize;
      if (!isLt2M) {
        this.fileList = [];
        this.$emit('returnData', []);
        this.$message.error(`文件大小不能超过${this.maxSize}M，请重新选择!`);
        return false;
      }
      this.disabled = true;
      this.loading = true;
      this.$emit('beginUpload');
    },
    // 手动导入文件
    submit() {
      this.loading = true;
      this.$emit('submit');
    },
  },
};
</script>

<style lang="less">
.upload {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;
  p {
    padding-right: 20px;
  }
  a {
    margin-left: 20px;
    color: #f60;
  }
  .el-upload-list {
    float: left;
  }
  .el-upload-list__item {
    margin: 3px 0 0 0;
  }
  .el-icon-right {
    font-size: 22px;
    padding: 0 5px;
  }
  /deep/ .el-button {
    margin-left: 0;
  }
  .import-tips {
    padding-left: 20px;
    font-size: 12px;
    color: #f00;
  }
}
</style>
